import { forwardRef } from 'react';
import {
  DropdownSelectedValueStyles,
  mapSizeToTypographyVariant,
} from '../variants.style';
import { AvatarStyleVariants } from '../../../atoms/avatar/variants';
import { Typography } from '../../../ui';
import { Avatar } from '../../../atoms/avatar/avatar';

type Props = {
  label: string;
  variant: AvatarStyleVariants['variant'];
  avatar: {
    initials: string;
    src?: string;
    alt?: string;
  };
  className?: string;
} & DropdownSelectedValueStyles;

export const DropdownSelectedAvatarValue = forwardRef<HTMLDivElement, Props>(
  ({ label, avatar, size, variant }, ref) => {
    return (
      <div className="flex flex-row items-center space-x-8" ref={ref}>
        <Avatar size={16} variant={variant} {...avatar} />
        <Typography
          variant={mapSizeToTypographyVariant(size)}
          weight="regular"
          className="flex-1 text-grayscale600"
        >
          {label}
        </Typography>
      </div>
    );
  },
);

DropdownSelectedAvatarValue.displayName = 'DropdownSelectedAvatarValue';
